





















































import './OpsMonitorBackendServices.scss'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import SubscribeRelease from '@/mixins/SubscribeRelease'
import NewVersion from './NewVersion'
import VersionSummary from './VersionSummary'
import { Button } from 'element-ui'
import Modal from '@/components/Modal'
import Vue from 'vue'
import { Release, Version } from '@/store/types'
import { AbilityAction, AbilitySubject } from '@/abilitiesByRole'

export default Vue.extend({
  name: 'OpsMonitorBackendServices',
  mixins: [SubscribeRelease],
  computed: {
    canDoOps (): boolean {
      return this.$can(AbilityAction.Do, AbilitySubject.Ops)
    },
    release (): Release | null {
      return this.$store.direct.state.admin.release
    },
    currentVersion (): string {
      return this.release?.default ?? 'unknown'
    }
  },
  data: () => ({
    showNewVersion: false,
    message: '',
    newVersion: {} as Version
  }),
  methods: {
    startNewRelease () {
      this.newVersion = {
        id: '',
        branch_front: '',
        branch_back: '',
        deploy_firebase: {
          rules: false,
          functions: false,
          manifests: false
        },
        services_enabled: {}
      }
      this.showNewVersion = true
    },
    addNewRelease () {
      this.$store.direct.dispatch.admin.addNewVersionToRelease(this.newVersion).then(() => {
        this.message = 'New release has been created, go to jenkins and deploy front and back with this branchname a parameter'
      }).catch(error => {
        this.message = error
      })
      this.showNewVersion = false
    },
    deleteVersion (version: string) {
      this.$confirm('Are you sure you want to delete this version?' +
                    'You need to manually shutdown the machine fro the backend', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.admin.deleteReleaseVersion(version)
        this.$message({
          type: 'success',
          message: 'This release has now been delete, dont forget to shutdown the machine as well'
        })
      }).catch(() => {
        //
      })
    },
    setDefaultVersion (version: string) {
      this.$confirm(`Are you sure you want to set the default version to ${version}?` +
                    'You need to manually deploy a frontend branch with this branchname as parameter', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        this.$store.direct.dispatch.admin.setDefaultReleaseVersion(version)
        this.$message({
          type: 'success',
          message: 'This release has is now the default version'
        })
      }).catch(() => {
        //
      })
    }
  },
  components: {
    VersionSummary,
    NewVersion,
    'el-button': Button,
    Modal,
    LeftSidebarLayout
  }
})
